var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimeGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.15,4.9C5.61,2,6.72,0,8,0s2.24,1.78,2.75,4.37A8.4,8.4,0,0,0,10,4.9ZM14.3,3.09a8,8,0,0,0-4-2.75,9.7,9.7,0,0,1,1.41,3.52A8.82,8.82,0,0,1,14.3,3.09ZM5,5.94a20,20,0,0,0,0,4.13H7.06A7.73,7.73,0,0,1,8.92,5.94ZM7,11.1H5.15C5.61,14,6.72,16,8,16a1.37,1.37,0,0,0,.69-.22A7.65,7.65,0,0,1,7,11.1ZM5.72.34A8,8,0,0,0,.62,4.9H4.11A10.84,10.84,0,0,1,5.72.34ZM.62,11.1a8,8,0,0,0,5.1,4.57A10.89,10.89,0,0,1,4.11,11.1ZM3.87,8c0-.69,0-1.39.11-2.06H.28a7.82,7.82,0,0,0,0,4.13H4C3.91,9.39,3.87,8.69,3.87,8ZM21,11a5.5,5.5,0,1,1-5.5-5.5A5.5,5.5,0,0,1,21,11Zm-1.06,0a4.44,4.44,0,1,0-4.44,4.44A4.43,4.43,0,0,0,19.93,11Zm-3.06,2.12a.27.27,0,0,0,.37-.06l.42-.57a.27.27,0,0,0-.06-.37L16.12,11V7.9a.27.27,0,0,0-.27-.27h-.71a.27.27,0,0,0-.27.27v3.64a.27.27,0,0,0,.11.22l1.88,1.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeGlobe);
export default __webpack_public_path__ + "static/media/icon-time-globe.3bb5fcd5d335669200925c35984323fa.svg";
export { ForwardRef as ReactComponent };